import { render } from "./RefPayoutBody.vue?vue&type=template&id=25f076c0"
import script from "./RefPayoutBody.vue?vue&type=script&lang=js"
export * from "./RefPayoutBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__